import { render } from "./accountAuditLists.vue?vue&type=template&id=6fbf6c32"
import script from "./accountAuditLists.vue?vue&type=script&lang=js"
export * from "./accountAuditLists.vue?vue&type=script&lang=js"

import "./accountAuditLists.vue?vue&type=style&index=0&id=6fbf6c32&lang=css"

import exportComponent from "C:\\Sunshine\\code\\zydt\\独立部署版\\ywym\\ydd-zht-api\\h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__